<script>
import Layout from "../../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { projectownerService } from "../../../../services/projectservice/projectowner.service";
import List from "../../../../components/list";
import i18n from "../../../../i18n";
/* eslint-disable no-console */
/**
 * Contacts-list component
 */
export default {
  page: {
    title: "Owner List",
    meta: [{ name: "description", content: appConfig.description }]
  },
  components: { Layout, PageHeader, List },
  data() {
    return {
      ownerList: {},
      fetchingStats: false,
      title: "Owner Templates List",

    };
  },
  mounted() {
    
    this.loadingData();
  },

  methods: {
    loadingData: function(param = '?page=0') {
      this.fetchingStats = false;
      projectownerService.getList(param)
        .then(response => {
          
          this.fetchingStats = true;
          this.ownerList = response;
        });
    },

    deleted: function(id) {
      projectownerService.remove(id)
        .then(response => {
        
          // this.customerData = response;
          if(response.status == 200) {
            this.$swal.fire({
              title: i18n.t('general.confirm.deleted'),
              text: i18n.t('general.confirm.success'),
              icon: "success",
              confirmButtonText: i18n.t('general.ok')
            });
          }
        });
    },

    pageNavigate: function(param) {
      this.loadingData(param);
    },

    submitAdd: function() {
      this.$router.push(this.$route.query.redirectFrom || {
              name: "setting-owner-add",
          });
    },

  }
};
</script>

<template>
  <Layout>
    <PageHeader :add="{icon: 'bx bx-add-to-queue bx-tada', title: 'general.new', link: 'setting-owner-add'}" :title="$t('setting.property.project-owner.text')" />
    <List v-bind:dataList="ownerList" 
          v-bind:updating="fetchingStats" 
          v-bind:navigate="pageNavigate"
          v-bind:formats="[]"
          v-bind:fields="[ `code: ${$t('setting.property.project-owner.code')}`, `name: ${$t('setting.property.project-owner.name')}`, 
            `phone_no: ${$t('setting.property.project-owner.phone-no')}`, `dob: ${$t('setting.property.project-owner.dob')}`, 
            `id_no: ${$t('setting.property.project-owner.id-no')}`, `email: ${$t('setting.property.project-owner.email')}`, 
            `address: ${$t('setting.property.project-owner.address')}`]" 
          v-bind:deletes="[deleted, null]"
          v-bind:edit="{link: 'setting-owner-edit'}"
          v-bind:filter="{
            search: ['project_owners.name', 'project_owners.name_en', 'project_owners.phone_no', 'project_owners.id_no'],
            dropdown: []
          }"
          
    />      
  </Layout>
</template>